'use client';

import { c as _c } from "react/compiler-runtime";
import { useEffect, useRef } from 'react';
import { Drawer } from '~/components/Drawer';
import { FlexibleDatesPanel } from '~/components/FlexibleDatesPanel';
import TransportApiLoader from '~/components/Loaders/TransportApiLoader';
import { TabsContainer } from '~/components/Tabs';
import { useIsDesktop } from '~/hooks/useIsDesktop';
import { type CreateTripTab, usePlaygroundActions, usePlaygroundContextParams, usePlaygroundPreferences, usePlaygroundUIState } from '~/stores/playgroundStore';
import { LoadingSpinner } from '../LoadingSpinner/LoadingSpinner';
import DestinationsPanel from './Drawers/DestinationsPanel';
import { PlaygroundStartEndPanel, PlaygroundStartEndTabs } from './PlaygroundStartEndTabs/PlaygroundStartEndTabs';
import TripDrawer from './TripDrawer/TripDrawer';
const DrawerWrapper = () => {
  const $ = _c(33);
  const {
    isDrawerOpen,
    drawerItem,
    createTripTab
  } = usePlaygroundUIState();
  const {
    destinations
  } = usePlaygroundContextParams();
  const destinationsOnOpen = useRef(destinations);
  const {
    closeDrawer,
    setTripPanelResult,
    setCreateTripTab,
    removeUnsupportedDestination
  } = usePlaygroundActions();
  const {
    unsupportedDestinations
  } = usePlaygroundPreferences();
  const isDesktop = useIsDesktop();
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = {
      "start-end": "Edit origin and end place",
      dates: "Edit travel dates",
      destinations: "Edit destinations",
      duration: "Edit duration",
      empty: "Empty drawer"
    };
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  const DRAWER_LABEL = t0;
  let t1;
  if ($[1] !== destinations || $[2] !== isDrawerOpen) {
    t1 = () => {
      if (isDrawerOpen === false) {
        destinationsOnOpen.current = destinations;
      }
    };
    $[1] = destinations;
    $[2] = isDrawerOpen;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  let t2;
  if ($[4] !== isDrawerOpen) {
    t2 = [isDrawerOpen];
    $[4] = isDrawerOpen;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  useEffect(t1, t2);
  let t3;
  if ($[6] !== closeDrawer || $[7] !== drawerItem || $[8] !== removeUnsupportedDestination || $[9] !== setTripPanelResult || $[10] !== unsupportedDestinations) {
    t3 = () => {
      if (drawerItem === "destinations" && unsupportedDestinations.length > 0) {
        unsupportedDestinations.forEach(place => {
          removeUnsupportedDestination(place.id);
        });
      }
      closeDrawer();
      setTripPanelResult(null);
    };
    $[6] = closeDrawer;
    $[7] = drawerItem;
    $[8] = removeUnsupportedDestination;
    $[9] = setTripPanelResult;
    $[10] = unsupportedDestinations;
    $[11] = t3;
  } else {
    t3 = $[11];
  }
  const onClose = t3;
  let t4;
  if ($[12] !== setCreateTripTab) {
    t4 = key => {
      setCreateTripTab(key as CreateTripTab);
    };
    $[12] = setCreateTripTab;
    $[13] = t4;
  } else {
    t4 = $[13];
  }
  let t5;
  if ($[14] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = <PlaygroundStartEndTabs />;
    $[14] = t5;
  } else {
    t5 = $[14];
  }
  let t6;
  if ($[15] !== createTripTab) {
    t6 = <PlaygroundStartEndPanel isHeroCta={false} variant="module" travelType={createTripTab} />;
    $[15] = createTripTab;
    $[16] = t6;
  } else {
    t6 = $[16];
  }
  let t7;
  if ($[17] !== createTripTab || $[18] !== t4 || $[19] !== t6) {
    t7 = <TabsContainer selectedKey={createTripTab} onSelectionChange={t4}>{t5}{t6}</TabsContainer>;
    $[17] = createTripTab;
    $[18] = t4;
    $[19] = t6;
    $[20] = t7;
  } else {
    t7 = $[20];
  }
  let t10;
  let t11;
  let t8;
  let t9;
  if ($[21] === Symbol.for("react.memo_cache_sentinel")) {
    t8 = <FlexibleDatesPanel layout="vertical" />;
    t9 = <DestinationsPanel />;
    t10 = <TripDrawer />;
    t11 = <></>;
    $[21] = t10;
    $[22] = t11;
    $[23] = t8;
    $[24] = t9;
  } else {
    t10 = $[21];
    t11 = $[22];
    t8 = $[23];
    t9 = $[24];
  }
  let t12;
  if ($[25] !== t7) {
    t12 = {
      "start-end": t7,
      dates: t8,
      destinations: t9,
      trip: t10,
      empty: t11
    };
    $[25] = t7;
    $[26] = t12;
  } else {
    t12 = $[26];
  }
  const DRAWER_ITEM = t12;
  const shouldShowDrawer = !isDesktop || drawerItem === "trip";
  if (!shouldShowDrawer) {
    return null;
  }
  const t13 = DRAWER_LABEL[drawerItem ?? "empty"];
  const t14 = drawerItem === "start-end" || drawerItem === "dates" || drawerItem === "destinations";
  const t15 = drawerItem && DRAWER_ITEM[drawerItem];
  let t16;
  if ($[27] !== isDrawerOpen || $[28] !== onClose || $[29] !== t13 || $[30] !== t14 || $[31] !== t15) {
    t16 = <Drawer isOpen={isDrawerOpen} close={onClose} ariaLabel={t13} maxWidth="442px" noHeader={t14}>{t15}</Drawer>;
    $[27] = isDrawerOpen;
    $[28] = onClose;
    $[29] = t13;
    $[30] = t14;
    $[31] = t15;
    $[32] = t16;
  } else {
    t16 = $[32];
  }
  return t16;
};
const LoadingSpinnerWrapper = () => {
  const $ = _c(3);
  const {
    isLoading,
    loadingTitle
  } = usePlaygroundUIState();
  let t0;
  if ($[0] !== isLoading || $[1] !== loadingTitle) {
    t0 = isLoading && <LoadingSpinner title={loadingTitle} />;
    $[0] = isLoading;
    $[1] = loadingTitle;
    $[2] = t0;
  } else {
    t0 = $[2];
  }
  return t0;
};
const TripLoaderWrapper = () => {
  const $ = _c(3);
  const {
    showAnimLoader,
    loadingMessages
  } = usePlaygroundUIState();
  let t0;
  if ($[0] !== loadingMessages || $[1] !== showAnimLoader) {
    t0 = showAnimLoader && <TransportApiLoader loadingMessages={loadingMessages} />;
    $[0] = loadingMessages;
    $[1] = showAnimLoader;
    $[2] = t0;
  } else {
    t0 = $[2];
  }
  return t0;
};
export { DrawerWrapper, LoadingSpinnerWrapper, TripLoaderWrapper };